import { useState, useEffect } from "react";
import Modal from "../ui/Modal";
import Input from "../ui/Input";
import Select from "../ui/Select";
import Button from "../ui/Button";

const blank = () => ({
  name: "",
  type: "recurring",
  description: "",
  department: "",
});

export default function OfferForm({ open, onClose, onSubmit, initial, departments = [] }) {
  const [form, setForm] = useState(() => initial || blank());
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) setForm(initial || blank());
    if (open) setErrors({});
  }, [open, initial]);

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.name.trim()) errs.name = "Name required";
    if (Object.keys(errs).length) { setErrors(errs); return; }
    onSubmit({ ...form, department: form.department || null });
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title={initial ? "Edit offer" : "Add offer"}>
      <form onSubmit={handleSubmit} className="space-y-3">
        <Input label="Name *" value={form.name} onChange={(e) => update("name", e.target.value)} error={errors.name} />
        <div className="grid grid-cols-2 gap-3">
          <Select label="Type" value={form.type} onChange={(e) => update("type", e.target.value)}>
            <option value="recurring">Recurring</option>
            <option value="oneoff">One-off</option>
          </Select>
          <Select label="Department" value={form.department || ""} onChange={(e) => update("department", e.target.value)}>
            <option value="">— None —</option>
            {departments.map((d) => <option key={d} value={d}>{d}</option>)}
          </Select>
        </div>
        {departments.length === 0 && (
          <p className="text-xs text-brand-slate -mt-2">Add departments in Settings → Taxonomies to group offers.</p>
        )}
        <label className="block">
          <span className="block text-xs font-medium text-brand-slate mb-1">Description</span>
          <textarea
            rows={2}
            value={form.description}
            onChange={(e) => update("description", e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-brand-blue/30 dark:bg-[var(--bg-soft)] dark:border-[var(--border-soft)] dark:text-[var(--text-primary)]"
          />
        </label>
        <p className="text-xs text-brand-slate">Pricing is set per-client on the Clients tab — each client can have a different monthly rate and setup fee for the same offer.</p>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="secondary" type="button" onClick={onClose}>Cancel</Button>
          <Button type="submit">{initial ? "Save" : "Add offer"}</Button>
        </div>
      </form>
    </Modal>
  );
}